var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCoins = function SvgCoins(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MOEDAS",
    transform: "translate(-43.302 -476.165)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_131",
    "data-name": "Elipse 131",
    cx: 26.5,
    cy: 26.5,
    r: 26.5,
    transform: "translate(44.302 477.165)",
    strokeWidth: 2,
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_212690984",
    transform: "translate(60.882 492.665)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_212678000",
    d: "M30.667,16.892v4.671c0,1.943-4.442,3.52-9.921,3.52s-9.921-1.576-9.921-3.52V16.892",
    transform: "translate(-10.825 -4.03)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_212915960",
    d: "M30.667,14.036v4.671c0,1.943-4.442,3.52-9.921,3.52s-9.921-1.576-9.921-3.52V14.036",
    transform: "translate(-10.825 -5.845)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_212685488",
    d: "M30.667,11.179V15.85c0,1.943-4.442,3.52-9.921,3.52s-9.921-1.576-9.921-3.52V11.179",
    transform: "translate(-10.825 -7.66)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_212676944",
    d: "M20.746,9.027c5.478,0,9.921,1.576,9.921,3.52s-4.442,3.52-9.921,3.52-9.921-1.576-9.921-3.52,4.442-3.52,9.921-3.52Z",
    transform: "translate(-10.825 -9.027)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    fillRule: "evenodd"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCoins, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/coins.348d9078.svg";
export { ForwardRef as ReactComponent };